import React from "react";
import { useLocation } from "react-router-dom";

export function useShortcut(callback: () => void, keyCodes: string[], disableHotkey?: boolean): void {
  const location = useLocation();

  React.useEffect(() => {
    const handler = (event: KeyboardEvent) => {
      const searchParams = new URLSearchParams(location.search);
      if (keyCodes.includes(event.key.toLowerCase()) && !searchParams.get("modal")) {
        callback();
      }
    };
    if (!disableHotkey) {
      window.addEventListener("keydown", handler);
      return () => {
        window.removeEventListener("keydown", handler);
      };
    }
  }, [disableHotkey, keyCodes, history, callback]);
}
